import React, { useEffect } from 'react';

import CheckboxInput from '../../../../Components/Inputs/CheckboxInput';
import StandardModal from "../../../../Components/Modals/StandardModal";

const HtmlFieldTermsAndCondition = (props) => {

    const [ isTCModalOpen, setIsTCModalOpen ] = React.useState(false);
    const [ userHasReadTerms, setUserHasReadTerms ] = React.useState(false);

    useEffect(() => {
        if (props.value === 'true' || props.value === true) {
            setUserHasReadTerms(true);
        }
    }, [props.value]);

    const handleTCLinkClick = (e) => {
        e.preventDefault();
        setIsTCModalOpen(true);
        setUserHasReadTerms(true);
    }

    return (<>
        <CheckboxInput
            name={props.field.id}
            disabled={!userHasReadTerms}
            onChange={props.onChange}
            onBlur={props.onBlur}
            checked={(props.value === 'true' || props.value === true)}
        />
        <a href="#"
            className="custom_form_t_and_c_link"
            onClick={handleTCLinkClick}
        >
            Click here to view terms and conditions
        </a>

        <StandardModal
            title="Terms & Conditions"
            open={isTCModalOpen}
            onClose={e => setIsTCModalOpen(false)}
            buttons={[
                <button
                    className="button primary"
                    onClick={e => setIsTCModalOpen(false)}
                >
                    OK
                </button>
            ]}
        >
            <div
                dangerouslySetInnerHTML={{__html: props.field.text}}
            />
        </StandardModal>
    </>);
};

HtmlFieldTermsAndCondition.propTypes = {};

HtmlFieldTermsAndCondition.defaultProps = {};

export default HtmlFieldTermsAndCondition;
